import Modal from "src/components/modal/modal";
import { FaUndo as RefundIcon } from "react-icons/fa";
import { RefundForm } from "./refund-form";
import { UserTransaction } from "../../types/user-transaction.entity";
import { RefundUserInfo } from "./user-info";
import { useGetUserByIdQuery } from "src/features/users/services/user.Service";

type Props = {
  transaction: UserTransaction;
  close: () => void;
};
export const RefundModal = ({ transaction, close }: Props) => {
  const { data: user } = useGetUserByIdQuery(transaction.userId);

  return (
    <Modal isOpen={true} size={3} onClose={close}>
      <div className="flex items-center justify-between pb-4 border-b border-gray-200">
        <div className="flex items-center space-x-3">
          <RefundIcon className="w-7 h-7 text-blue-600" />
          <h2 className="text-lg font-semibold text-gray-900">Refund Session Money</h2>
        </div>
      </div>
      {user ? (
        <>
          <RefundUserInfo user={user} />
          <RefundForm transaction={transaction} close={close} user={user} />
        </>
      ) : null}
    </Modal>
  );
};
